import React from 'react'
import { Routes, Route, useLocation } from "react-router-dom";
import Layout from '../layout/Layout';
import Fallbacksuspense from './Fallbacksuspense';
import ScrollOnTop from '../ScrollOnTop'
import { ProtectedRouter } from '../ProtectedRouter';
import Login from '../pages/Admin/Login'
import { ErrorBoundary } from 'react-error-boundary';
import ErrorPage from '../components/ErrorPages/ErrorPage'
import About from "../pages/About";
import Home from "../pages/Home";
import Services from "../pages/Services";
import Portfolio from "../pages/Portfolio";
import Contact from "../pages/Contact";


function AnimatedRoutes() {
    const location = useLocation();
    // const LazyHomeScreen = React.lazy(() => import("../pages/Home"));
    // const LazyServicesScreen = React.lazy(() => import("../pages/Services"));
    // const LazyPortfolioScreen = React.lazy(() => import("../pages/portfolios/ExplorePortfolio"));
    // const LazyContactScreen = React.lazy(() => import("../pages/Contact"));
    // const LazyAboutScreen = React.lazy(() => import("../pages/About"));
    const LazyServicesPageScreen = React.lazy(() => import("../pages/services/ServicesPage"));
    const LazyPotfolioGalleryPageScreen = React.lazy(() => import("../components/Portfolio/PortfolioGallery"));
    const LazyNotFound = React.lazy(() => import("../pages/NotFound"));
    const LazyDashboard = React.lazy(() =>
        import("../pages/Admin/Dashboard")
    );
    return (
        <ErrorBoundary FallbackComponent={ErrorPage} onReset={() => location.pathname = "/"}>

            <Routes>
                <Route path="/" element={<Layout />}>
                    {/* since we remove lazyloading screens as this is not working for smoothscorlling in the single page tabs */}
                    {/* <Route index element={
                        <LazyHomeScreen />
                    } />
                    <Route path="/about" element={
                        <LazyAboutScreen />
                    } />
                    <Route path="/services" element={
                        <LazyServicesScreen />
                    } />
                    <Route path="/portfolio" element={
                        <ScrollOnTop>
                            <LazyPortfolioScreen />
                        </ScrollOnTop>
                    } />
                    <Route path="/contact" element={
                        <LazyContactScreen />
                    } /> */}
                     <Route index element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/contact" element={<Contact />} />
                    <Route path="/portfolio-gallery" element={
                        <ScrollOnTop>
                            <LazyPotfolioGalleryPageScreen />
                        </ScrollOnTop>
                    } />
                    <Route path="/services_page" element={
                        <ScrollOnTop>
                            <LazyServicesPageScreen />
                        </ScrollOnTop>

                    } />

                </Route>
                <Route exact path="/login" element={<Login />} />
                <Route path="/" element={<ProtectedRouter />}>
                    <Route
                        path="/dashboard"
                        element={
                            <React.Suspense fallback={<Fallbacksuspense />}>
                                <LazyDashboard />
                            </React.Suspense>
                        }
                    />
                </Route>
                <Route
                    path="*"
                    element={
                        <React.Suspense fallback={<Fallbacksuspense />}>
                            <LazyNotFound />
                        </React.Suspense>
                    }
                />
            </Routes>
        </ErrorBoundary>
    )
}

export default AnimatedRoutes